import { goto } from '$app/navigation'
import { fbData, fbKey } from './fbUrlParams'

export function autoLogin() {
	// load firebase user from query parameters if available (and before initialization of auth)
	const url = new URL(location.href)

	const params = url.searchParams
	if (params.has(fbKey) && params.has(fbData)) {
		window.localStorage.setItem(
			params.get(fbKey),
			decodeURIComponent(window.atob(params.get(fbData))),
		)

		url.searchParams.delete(fbKey)
		url.searchParams.delete(fbData)

		goto(url, { replaceState: true })
	}
}
